import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextEditor.css';

const fullToolbar = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ font: [] }],
  [{ size: ['small', false, 'large', 'huge'] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],
  [{ align: [] }],
  ['link', 'image', 'video'],
  ['blockquote', 'code-block'],
  ['clean']
];

const resourceToolbar = [
  [{ header: [2, 3, false] }],
  ['bold', 'italic', 'underline'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link', 'image'],
  ['clean']
];

const fullFormats = [
  'header', 'font', 'size', 'bold', 'italic', 'underline', 'strike',
  'color', 'background', 'script', 'list', 'bullet', 'indent',
  'direction', 'align', 'link', 'image', 'video', 'blockquote', 'code-block'
];

const resourceFormats = ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link', 'image'];

const RichTextEditor = ({ value, onChange, placeholder = 'Start writing...', height = '300px', variant = 'full' }) => {
  const modules = useMemo(() => ({
    toolbar: variant === 'resource' ? resourceToolbar : fullToolbar,
    clipboard: { matchVisual: false }
  }), [variant]);
  const formats = variant === 'resource' ? resourceFormats : fullFormats;

  return (
    <div className={`rich-text-editor-wrapper ${variant === 'resource' ? 'resource-editor' : ''}`}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{ height }}
      />
    </div>
  );
};

export default RichTextEditor;
